module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "Select 选择器",
      "description": "当选项过多时，使用下拉菜单展示并选择内容。",
      "show-content": false
    }
  }), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "基础用法",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode1
    }
  }, [_c('template', {
    slot: "description"
  }), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('vm-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            v-model的值为当前被选中的"), _c('br'), _vm._v("\n            vm-option的 value 属性值\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "有禁用选项",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode2
    }
  }, [_c('template', {
    slot: "description"
  }), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('vm-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            在vm-option中，设定disabled值为 true，即可禁用该选项\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "禁用状态",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode3
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            选择器不可用状态\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('vm-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            为vm-select设置disabled属性，则整个选择器不可用\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "可清空单选",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode4
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            包含清空按钮，可将选择器清空为初始状态\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('vm-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            为vm-select设置clearable属性，则可将选择器清空。需要注意的是，clearable属性仅适用于单选。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "基础多选",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode5
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            适用性较广的基础多选，用 Tag 展示已选项\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('vm-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            为vm-select设置multiple属性即可启用多选，此时v-model的值为当前选中值所组成的数组\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "自定义模板",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode6
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            可以自定义备选项\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  }, _vm._l((_vm.cities), function(item) {
    return _c('vm-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.value))])])
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            将自定义的 HTML 模板插入vm-option的 slot 中即可。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "分组",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode7
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            备选项进行分组展示\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value7),
      callback: function($$v) {
        _vm.value7 = $$v
      },
      expression: "value7"
    }
  }, _vm._l((_vm.options3), function(group) {
    return _c('vm-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item) {
      return _c('vm-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }))
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            使用vm-option-group对备选项进行分组，它的label属性为分组名\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "可搜索",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode8
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            可以利用搜索功能快速查找选项\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value8),
      callback: function($$v) {
        _vm.value8 = $$v
      },
      expression: "value8"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('vm-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            为vm-select添加filterable属性即可启用搜索功能。默认情况下，Select 会找出所有label属性包含输入值的选项。如果希望使用其他的搜索逻辑，可以通过传入一个filter-method来实现。filter-method为一个Function，它会在输入值发生变化时调用，参数为当前输入值。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "远程搜索",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode9
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            从服务器搜索数据，输入关键字进行查找\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.value9),
      callback: function($$v) {
        _vm.value9 = $$v
      },
      expression: "value9"
    }
  }, _vm._l((_vm.options4), function(item) {
    return _c('vm-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            为了启用远程搜索，需要将filterable和remote设置为true，同时传入一个remote-method。remote-method为一个Function，它会在输入值发生变化时调用，参数为当前输入值。需要注意的是，如果vm-option是通过v-for指令渲染出来的，此时需要为vm-option添加key属性，且其值需具有唯一性，比如此例中的item.value。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "创建条目",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode10
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            可以创建并选中选项中不存在的条目\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "请选择文章标签"
    },
    model: {
      value: (_vm.value10),
      callback: function($$v) {
        _vm.value10 = $$v
      },
      expression: "value10"
    }
  }, _vm._l((_vm.options5), function(item) {
    return _c('vm-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            使用 allow-create 属性即可通过在输入框中输入文字来创建新的条目。注意此时 filterable 必须为真。\n        ")])], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "attributes"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#attributes",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n            Select Attributes\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("multiple")]), _vm._v(" "), _c('td', [_vm._v("是否多选")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', [_vm._v("是否禁用")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value-key")]), _vm._v(" "), _c('td', [_vm._v("作为 value 唯一标识的键名，绑定值为对象类型时必填")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("value")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("inputheight")]), _vm._v(" "), _c('td', [_vm._v("当为多选时，可通过inputheight 修改 Select input框的高度")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("36")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("inputclass")]), _vm._v(" "), _c('td', [_vm._v("Select input框的类名，当为多选时，无法改变高度，高度只能通过inputheight属性设置")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("clearable")]), _vm._v(" "), _c('td', [_vm._v("单选时是否可以清空选项")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("multiple-limit")]), _vm._v(" "), _c('td', [_vm._v("多选时用户最多可以选择的项目数，为 0 则不限制")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("select input 的 name 属性")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("placeholder")]), _vm._v(" "), _c('td', [_vm._v("占位符")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("请选择")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("filterable")]), _vm._v(" "), _c('td', [_vm._v("是否可搜索")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("allow-create")]), _vm._v(" "), _c('td', [_vm._v("是否允许用户创建新条目，需配合 filterable 使用")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("filter-method")]), _vm._v(" "), _c('td', [_vm._v("自定义过滤方法")]), _vm._v(" "), _c('td', [_vm._v("function")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("remote")]), _vm._v(" "), _c('td', [_vm._v("是否为远程搜索")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("remote-method")]), _vm._v(" "), _c('td', [_vm._v("远程搜索方法")]), _vm._v(" "), _c('td', [_vm._v("function")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("loading")]), _vm._v(" "), _c('td', [_vm._v("是否正在从远程获取数据")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("loading-text")]), _vm._v(" "), _c('td', [_vm._v("远程加载时显示的文字")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("加载中")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("no-match-text")]), _vm._v(" "), _c('td', [_vm._v("搜索条件无匹配时显示的文字")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("无匹配数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("no-data-text")]), _vm._v(" "), _c('td', [_vm._v("选项为空时显示的文字")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("无数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("popper-class")]), _vm._v(" "), _c('td', [_vm._v("Select 下拉框的类名")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-first-option")]), _vm._v(" "), _c('td', [_vm._v("在输入框按下回车，选择第一个匹配项。需配合 filterable 或 remote 使用")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "event"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#event",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n            Select Events\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("change")]), _vm._v(" "), _c('td', [_vm._v("选中值发生变化时触发")]), _vm._v(" "), _c('td', [_vm._v("目前的选中值")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("visible-change")]), _vm._v(" "), _c('td', [_vm._v("下拉框出现/隐藏时触发")]), _vm._v(" "), _c('td', [_vm._v("出现则为 true，隐藏则为 false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("remove-tag")]), _vm._v(" "), _c('td', [_vm._v("多选模式下移除tag时触发")]), _vm._v(" "), _c('td', [_vm._v("移除的tag值")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("clear")]), _vm._v(" "), _c('td', [_vm._v("可清空的单选模式下用户点击清空按钮时触发")]), _vm._v(" "), _c('td', [_vm._v("—")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "optionGroupAttributes"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#optionGroupAttributes",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n            Option Group Attributes\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', [_vm._v("分组的组名")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', [_vm._v("是否将该分组下所有选项置为禁用")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "optionAttributes"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#optionAttributes",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n            Option Attributes\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', [_vm._v("选项的值")]), _vm._v(" "), _c('td', [_vm._v("string/number/object")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', [_vm._v("选项的标签，若不设置则默认与 value 相同")]), _vm._v(" "), _c('td', [_vm._v("string/number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', [_vm._v("是否禁用该选项")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ccf60ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 36
// module chunks = 0